var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2531 10.0969C2.84894 9.2961 2.63845 8.4047 2.6399 7.5C2.6399 4.3925 5.0567 1.875 8.0399 1.875C11.0231 1.875 13.4399 4.3925 13.4399 7.5C13.4399 8.4425 13.2179 9.33625 12.8213 10.115",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99957 6.45185C10.0041 6.72535 9.95638 6.99707 9.85907 7.25113C9.76175 7.5052 9.61683 7.73653 9.43277 7.93163C9.24871 8.12673 9.02919 8.2817 8.78702 8.38748C8.54484 8.49326 8.28487 8.54773 8.02227 8.54773C7.75967 8.54773 7.4997 8.49326 7.25753 8.38748C7.01536 8.2817 6.79583 8.12673 6.61177 7.93163C6.42771 7.73653 6.28279 7.5052 6.18548 7.25113C6.08816 6.99707 6.0404 6.72535 6.04497 6.45185C6.054 5.9118 6.2663 5.39705 6.63613 5.01846C7.00596 4.63987 7.50375 4.42773 8.02227 4.42773C8.5408 4.42773 9.03858 4.63987 9.40841 5.01846C9.77825 5.39705 9.99054 5.9118 9.99957 6.45185ZM11.1042 12.1275C10.2039 12.7772 9.1346 13.125 8.03937 13.1244C6.93397 13.1263 5.85513 12.7715 4.95117 12.1087C5.07357 11.1175 5.92017 10.0169 8.02197 10.0169C10.1466 10.0169 10.9878 11.1237 11.1042 12.1275Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.de4e44c670211e684b63334ff3a378c6.svg";
export { ForwardRef as ReactComponent };